import { styled } from '@mui/material/styles';
import { RaisinContainer as Container, Typography } from '@raisin/components-lib';
const commonCopyStyling = (theme) => ({
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.subtitle2.fontWeight,
    lineHeight: '18px',
});
export const CountryPickerWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(2, 0),
    backgroundColor: theme.palette.black10.main,
}));
export const BannerCopy = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, commonCopyStyling(theme)), { [theme.breakpoints.down('md')]: {
        width: '100%',
    } })));
export const LineBreak = styled('br')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));
export const FlexContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        position: 'relative',
    },
}));
//# sourceMappingURL=styles.js.map